/**
 * vue-sparklines v2.0.1
 * (c) 2022 tangzhen@me.com
 * @license MIT
 */

import arrayMin from '../utils/min.js';
import arrayMax from '../utils/max.js';
import mean from '../utils/mean.js';
import midRange from '../utils/midRange.js';
import median from '../utils/median.js';
import stdev from '../utils/stdev.js';
import variance from '../utils/variance.js';
import dataToPoints from '../utils/dataToPoints.js';
import debounce from '../utils/debounce.js';
import genColor from '../utils/genColor.js';
import uid from '../utils/uid.js';
import isEmpty from '../utils/isEmpty.js';

var utils = /*#__PURE__*/Object.freeze({
	__proto__: null,
	min: arrayMin,
	max: arrayMax,
	mean: mean,
	avg: mean,
	midRange: midRange,
	median: median,
	stdev: stdev,
	variance: variance,
	dataToPoints: dataToPoints,
	debounce: debounce,
	color: genColor,
	uid: uid,
	isEmpty: isEmpty
});

export { utils as u };
//# sourceMappingURL=dep-680ea5a1.js.map
